import Frame from "../components/Frame";
import { EarIcon } from "../components/Icons";
import ResetTablet from "../components/ResetTablet";
import ui from "../components/ui.module.css";

// Quiet before release: attention belongs to the teacher. The adult's reset
// sits small at the foot of the screen.
const Waiting = ({ onReset }) => (
  <Frame centered>
    <span className={`${ui.bigIcon} ${ui.breathe}`}>
      <EarIcon size={72} />
    </span>
    <h1 className={ui.learnerTitle}>Listen to your teacher</h1>
    {onReset && (
      <div style={{ position: "fixed", bottom: 12, right: 16 }}>
        <ResetTablet onReset={onReset} />
      </div>
    )}
  </Frame>
);

export default Waiting;
